import React from 'react';

const GoBackArrow = () => {
  return (
    <div 
      className="allow-pointer-cursor d-block d-sm-inline pe-2" 
      onClick={() => window.history.go(-1)}
    >
      <i 
        title="Regresar"
        style={{fontSize: "1.5rem"}}
        className="color-gris-megatone fa fa-arrow-left" 
      />
    </div>
  )
}

export default GoBackArrow